(function () {
  'use strict';

  document.querySelectorAll('.spc-overlay').forEach(function (overlay) {
    var overlayId  = overlay.id;
    var reviewsUrl = overlay.dataset.reviewsUrl || '';

    var sheet   = overlay.querySelector('.spc-overlay__sheet');
    var content = overlay.querySelector('.spc-overlay__content');
    var loader  = overlay.querySelector('.spc-overlay__loader');

    var triggers    = document.querySelectorAll('[aria-controls="' + overlayId + '"][data-spc-trigger]');
    var closers     = overlay.querySelectorAll('[data-spc-close]');
    var contentLoaded = false;
    var touchStartY   = 0;
    var currentDrag   = 0;

    // ─── Fetch & inject page content ───
    function loadContent() {
      if (contentLoaded) return;
      if (!reviewsUrl) {
        loader.innerHTML = '<p style="color:#999;font-size:14px;padding:20px;text-align:center">Keine URL konfiguriert.</p>';
        return;
      }
      contentLoaded = true;

      // Analytics/Tracking-Scripts die NICHT re-executed werden sollen
      var BLOCKED_PATTERNS = [
        'clarity', 'trekkie', 'monorail',
        'shop-cart-sync', 'init-shop-cart-sync',
        'web-pixel', 'web_pixel',
        'static.klaviyo.com',        // onsite tracking only – reviews app is cdn.shopify.com/.../klaviyo-email-marketing
        'googletagmanager', 'google-analytics', 'gtag.js',
        'hotjar', 'matomo', 'analytics.ayni.de',
        'facebook.net', 'connect.facebook',
        'snapchat', 'tiktok',
        'cdn.shopify.com/s/trekkie'
      ];

      function isBlockedScript(scriptEl) {
        var src  = (scriptEl.getAttribute('src') || '').toLowerCase();
        var text = (scriptEl.textContent || '').toLowerCase();
        // Inline-Scripts mit typischen Analytics-Signalen blocken
        if (!src && (text.includes('trekkie') || text.includes('ShopifyAnalytics') || text.includes('_satellite'))) return true;
        return BLOCKED_PATTERNS.some(function (p) { return src.includes(p); });
      }

      fetch(reviewsUrl, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var parser  = new DOMParser();
          var doc     = parser.parseFromString(html, 'text/html');
          var main    = doc.querySelector('#MainContent') || doc.querySelector('main') || doc.body;
          var wrapper = document.createElement('div');
          wrapper.innerHTML = main.innerHTML;

          // Externe Stylesheets entfernen (können Overlay-Layout brechen)
          wrapper.querySelectorAll('link[rel="stylesheet"]').forEach(function (el) { el.remove(); });

          // Scripts: Analytics blocken, Review-Widgets durchlassen
          wrapper.querySelectorAll('script').forEach(function (oldScript) {
            if (isBlockedScript(oldScript)) { oldScript.remove(); return; }
            var newScript = document.createElement('script');
            var src = oldScript.getAttribute('src');
            if (src) {
              newScript.src   = src;
              newScript.async = true;
              // type=module weiterleiten wenn vorhanden
              if (oldScript.type) newScript.type = oldScript.type;
            } else {
              try { newScript.textContent = oldScript.textContent; } catch (e) { oldScript.remove(); return; }
            }
            oldScript.replaceWith(newScript);
          });

          content.appendChild(wrapper);
          loader.classList.add('is-hidden');

          // ── Trustpilot: script already on main page — re-init injected elements ──
          setTimeout(function() {
            if (window.Trustpilot && window.Trustpilot.loadFromElement) {
              content.querySelectorAll('.trustpilot-widget').forEach(function(el) {
                window.Trustpilot.loadFromElement(el, true);
              });
            }
          }, 300);

          // ── review-widget.net (grwapi.net) ──
          // Replace with a srcdoc iframe so the widget script gets a fresh
          // document and a clean DOMContentLoaded cycle (no singleton guards).
          content.querySelectorAll('.review-widget_net').forEach(function(el) {
            var attrs = Array.from(el.attributes).map(function(a) {
              return a.name + '="' + a.value.replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '"';
            }).join(' ');
            var rw = document.createElement('iframe');
            rw.style.cssText = 'width:100%;border:none;display:block;min-height:120px';
            rw.srcdoc = '<!DOCTYPE html><html><head>'
              + '<meta name="viewport" content="width=device-width,initial-scale=1">'
              + '<style>html,body{margin:0;padding:0;overflow-x:hidden}</style>'
              + '</head><body>'
              + '<div ' + attrs + '></div>'
              + '<script src="https://grwapi.net/widget.min.js"><\/script>'
              + '<script>new ResizeObserver(function(){parent.postMessage({_rw_h:document.body.scrollHeight},"*")}).observe(document.body)<\/script>'
              + '</body></html>';
            el.replaceWith(rw);
            window.addEventListener('message', function(e) {
              if (e.data && typeof e.data._rw_h === 'number') rw.style.height = (e.data._rw_h + 24) + 'px';
            });
          });

          // ── Klaviyo reviews ──
          // Replace with a srcdoc iframe containing all Klaviyo scripts
          // extracted from the fetched document (fresh execution, correct order).
          var klaviyoEl = content.querySelector('#klaviyo-reviews-all');
          if (klaviyoEl) {
            var klScripts = [];
            var klCss    = [];
            doc.querySelectorAll('script[src]').forEach(function(s) {
              var src = s.getAttribute('src') || '';
              if (src.includes('klaviyo')) klScripts.push(src);
            });
            doc.querySelectorAll('link[rel="stylesheet"]').forEach(function(l) {
              var href = l.getAttribute('href') || '';
              if (href.includes('klaviyo-email-marketing')) klCss.push(href);
            });
            var cssHtml     = klCss.map(function(h) { return '<link rel="stylesheet" href="' + h + '">'; }).join('');
            var scriptsHtml = klScripts.map(function(s) { return '<script src="' + s + '"><\/script>'; }).join('');
            var kl = document.createElement('iframe');
            kl.style.cssText = 'width:100%;border:none;display:block;min-height:200px';
            kl.srcdoc = '<!DOCTYPE html><html><head>'
              + '<meta name="viewport" content="width=device-width,initial-scale=1">'
              + '<style>html,body{margin:0;padding:0;overflow-x:hidden}</style>'
              + cssHtml
              + '</head><body>'
              + '<div id="klaviyo-reviews-all" data-id="all"></div>'
              + scriptsHtml
              + '<script>new ResizeObserver(function(){parent.postMessage({_kl_h:document.body.scrollHeight},"*")}).observe(document.body)<\/script>'
              + '</body></html>';
            klaviyoEl.replaceWith(kl);
            window.addEventListener('message', function(e) {
              if (e.data && typeof e.data._kl_h === 'number') kl.style.height = (e.data._kl_h + 24) + 'px';
            });
          }
        })
        .catch(function (err) {
          console.warn('[SPC] Fetch fehlgeschlagen:', err);
          loader.innerHTML = '<p style="color:#999;font-size:14px;padding:20px;text-align:center">Inhalte konnten nicht geladen werden.</p>';
        });
    }

    // ─── Open ───
    function openOverlay() {
      overlay.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      loadContent();
    }

    // ─── Close ───
    function closeOverlay() {
      overlay.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      sheet.style.transform = '';
    }

    // ─── Events ───
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openOverlay(); });
    });

    closers.forEach(function (el) {
      el.addEventListener('click', closeOverlay);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });

    // ─── Swipe-to-close ───
    sheet.addEventListener('touchstart', function (e) {
      touchStartY = e.touches[0].clientY;
      currentDrag = 0;
      sheet.setAttribute('data-dragging', '');
    }, { passive: true });

    sheet.addEventListener('touchmove', function (e) {
      var delta = e.touches[0].clientY - touchStartY;
      if (delta > 0) { currentDrag = delta; sheet.style.transform = 'translateY(' + delta + 'px)'; }
    }, { passive: true });

    sheet.addEventListener('touchend', function () {
      sheet.removeAttribute('data-dragging');
      if (currentDrag > 120) { closeOverlay(); } else { sheet.style.transform = ''; }
      currentDrag = 0;
    });

    // ─── Focus trap ───
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !overlay.classList.contains('is-open')) return;
      var focusable = overlay.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
        e.preventDefault(); (e.shiftKey ? last : first).focus();
      }
    });
  });
})();